var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.vz=require("ttag");module.exports=$CLJS.vz;